import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'emotion-theming';
import classnames from 'classnames';

var ButtonTitle = function ButtonTitle(_ref) {
  var children = _ref.children;
  return React.createElement('span', {
    className: 'c-a-button__title'
  }, children);
};

ButtonTitle.propTypes = {
  children: PropTypes.node
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var wrapTextNodes = function wrapTextNodes(children) {
  return React.Children.map(children, function (child) {
    return typeof child === 'string' ? React.createElement(ButtonTitle, null, child) : child;
  });
};
/**
 * The Anchor component is very similar to the Button component.
 * The main difference being that the main component tag is a hyperlink rather than a button.
 */


var Anchor = function Anchor(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      display = _ref.display,
      href = _ref.href,
      pill = _ref.pill,
      size = _ref.size,
      width = _ref.width,
      willOpenNewWindow = _ref.willOpenNewWindow;
  var allClassNames = classnames(className, 'c-a-button', (_classnames = {}, defineProperty(_classnames, 'c-a-button--width-' + width, width), defineProperty(_classnames, 'c-a-button--size-' + size, size), defineProperty(_classnames, 'c-a-button--' + display, display), defineProperty(_classnames, 'c-a-button--pill', pill), _classnames));
  return React.createElement('a', {
    className: allClassNames,
    href: href,
    disabled: disabled,
    target: willOpenNewWindow ? '_blank' : null
  }, wrapTextNodes(children));
};

Anchor.propTypes = {
  /** Either a single node, or array of nodes which will be rendered as Anchor children. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** A custom class name. */
  className: PropTypes.string,

  /** Sets a disabled behaviour and style on the Anchor */
  disabled: PropTypes.bool,

  /** Set one of the default Anchor styles from the available options. */
  display: PropTypes.oneOf(['primary', 'secondary']),

  /** Provide a destination URL for the Anchor. Required as hyperlinks are invalid without an href attribute. */
  href: PropTypes.string.isRequired,

  /** Enables the pill styling option. */
  pill: PropTypes.bool,

  /** Set the Anchor size from the available options. */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),

  /** Set the Anchor width from the available options. */
  width: PropTypes.oneOf(['flush', 'narrow', 'wide', 'full']),

  /** Specifies whether the anchor opens a new browser window. */
  willOpenNewWindow: PropTypes.bool
};
Anchor.defaultProps = {
  disabled: false,
  pill: false,
  size: 'md',
  willOpenNewWindow: false
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var LoadingOutlineSmallIcon = function LoadingOutlineSmallIcon(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z"
  }));
};

var wrapTextNodes$1 = function wrapTextNodes(children) {
  return React.Children.map(children, function (child) {
    return typeof child === 'string' ? React.createElement(ButtonTitle, null, child) : child;
  });
};

var Button = function (_Component) {
  inherits(Button, _Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.buttonRef = null;
    return _this;
  }

  createClass(Button, [{
    key: 'focus',
    value: function focus() {
      if (this.buttonRef) {
        this.buttonRef.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this; // eslint-disable-next-line react/prop-types


      var _props = this.props,
          children = _props.children,
          isLoading = _props.isLoading,
          loadingText = _props.loadingText,
          width = _props.width,
          display = _props.display,
          size = _props.size,
          className = _props.className,
          disabled = _props.disabled,
          rest = objectWithoutProperties(_props, ['children', 'isLoading', 'loadingText', 'width', 'display', 'size', 'className', 'disabled']);
      var allClassNames = classnames(className, 'c-a-button', (_classnames = {}, defineProperty(_classnames, 'c-a-button--width-' + width, width), defineProperty(_classnames, 'c-a-button--size-' + size, size), defineProperty(_classnames, 'c-a-button--' + display, display), defineProperty(_classnames, 'c-a-button--is-spinning', isLoading), _classnames));

      var buttonProps = _extends({
        disabled: isLoading || disabled
      }, isLoading && {
        'aria-live': 'polite'
      }, isLoading && {
        'aria-busy': 'true'
      }, rest);

      return React.createElement('button', _extends({
        className: allClassNames,
        ref: function ref(component) {
          _this2.buttonRef = component;
        }
      }, buttonProps), wrapTextNodes$1(children), isLoading && React.createElement('div', {
        className: 'c-a-button__loading-spinner'
      }, React.createElement('span', {
        className: 'c-a-button__loading-spinner-icon'
      }, React.createElement(LoadingOutlineSmallIcon, null)), React.createElement('span', {
        className: 'c-a-button__loading-spinner-label'
      }, loadingText)));
    }
  }]);
  return Button;
}(Component);

Button.propTypes = {
  /** Child content as single node or array of nodes. */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

  /** Sets a custom class name. */
  className: PropTypes.string,

  /** Controls the button disabled state. */
  disabled: PropTypes.bool,

  /** Specify a display type. */
  display: PropTypes.oneOf(['primary', 'secondary']),

  /** Controls the loading state of the button. */
  isLoading: PropTypes.bool,

  /** Sets the text when the isLoading prop is set to true. */
  loadingText: PropTypes.string,

  /** Click handler invoked when the button is clicked. */
  onClick: PropTypes.func,

  /** Sets the size. */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),

  /** Sets the width. */
  width: PropTypes.oneOf(['flush', 'narrow', 'wide', 'full'])
};
Button.defaultProps = {
  isLoading: false,
  loadingText: 'Loading',
  size: 'md',
  disabled: false
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var ChevronLeftSmall = function ChevronLeftSmall(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("title", null, "icon-chevronleft-small"), React.createElement("path", {
    d: "M17 17.364L14.522 20 7 12l7.522-8L17 6.635 11.958 12"
  }));
};

var BackAnchor = function BackAnchor(_ref) {
  var disabled = _ref.disabled,
      href = _ref.href,
      label = _ref.label;
  return React.createElement(Anchor, {
    className: 'c-a-button--unpadded',
    disabled: disabled,
    href: href,
    size: 'xs'
  }, React.createElement(ChevronLeftSmall, {
    className: 'c-a-icon'
  }), label);
};

BackAnchor.propTypes = {
  /** Whether the anchor is visually disabled. */
  disabled: PropTypes.bool,

  /** The URL to be used as the link destination. */
  href: PropTypes.string.isRequired,

  /** The anchor text label. */
  label: PropTypes.string
};
BackAnchor.defaultProps = {
  disabled: false,
  label: 'Back'
};
var WrappedBackAnchor = withTheme(BackAnchor);

var BackButton = function BackButton(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      onClick = _ref.onClick;
  return React.createElement(Button, {
    className: 'c-a-button--unpadded',
    disabled: disabled,
    onClick: onClick,
    size: 'xs'
  }, React.createElement(ChevronLeftSmall, {
    className: 'c-a-icon'
  }), label);
};

BackButton.propTypes = {
  /** Whether the anchor is disabled. */
  disabled: PropTypes.bool,

  /** Click handler to be passed to the button. */
  onClick: PropTypes.func.isRequired,

  /** The button text label. */
  label: PropTypes.string
};
BackButton.defaultProps = {
  disabled: false,
  label: 'Back'
};
var WrappedBackButton = withTheme(BackButton);

var Utility = function Utility(_ref) {
  var left = _ref.left,
      right = _ref.right;
  var rightProps = Object.assign({
    className: 'c-m-utility-nav__link'
  }, right && right.link && {
    href: right.link
  }, right && right.onClick && {
    onClick: right.onClick
  });
  var leftProps = Object.assign({
    className: 'c-m-utility-nav__link'
  }, left && left.link && {
    href: left.link
  }, left && left.onClick && {
    onClick: left.onClick
  });
  return React.createElement('nav', {
    className: 'c-m-utility-nav'
  }, React.createElement('div', {
    className: 'c-m-utility-nav__control'
  }, React.createElement('div', {
    className: 'c-m-utility-nav__control-cell'
  }, left && React.createElement('a', leftProps, left.media, left.title && React.createElement('div', {
    className: 'c-m-utility-nav__link-title'
  }, left.title))), React.createElement('div', {
    className: 'c-m-utility-nav__control-cell u-text-align-right'
  }, right && React.createElement('a', rightProps, right.title && React.createElement('div', {
    className: 'c-m-utility-nav__link-title'
  }, right.title), right.media))));
};

var CellPropTypes = PropTypes.shape({
  link: PropTypes.string,
  media: PropTypes.node,
  onClick: PropTypes.func,
  title: PropTypes.string
});
Utility.propTypes = {
  left: CellPropTypes,
  right: CellPropTypes
};
export { WrappedBackAnchor as BackAnchor, WrappedBackButton as BackButton, Utility };